export const isNotPast = (rectangle) => {
  if (rectangle.expirationDate === null) return true
  const expirationDate = Date.parse(rectangle.expirationDate)
  const now = Date.now()
  return expirationDate >= now
}
